// src/App.js

import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes, useLocation } from 'react-router-dom';
import InferenceForm from './components/InferenceForm';
import InferenceLogs from './components/InferenceLogs';
import Login from './components/Login';
import Admin from './components/Admin';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

function NavBar() {
  const location = useLocation();
  const { session, isAdmin, signOut } = useAuth();
  return (
    <nav className="main-nav">
      <ul>
        <li>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Content Generation</Link>
        </li>
        <li>
          <Link to="/logs" className={location.pathname === '/logs' ? 'active' : ''}>History</Link>
        </li>
        {isAdmin && (
          <li>
            <Link to="/admin" className={location.pathname === '/admin' ? 'active' : ''}>Admin</Link>
          </li>
        )}
        {session && (
          <li>
            <button type="button" className="sign-out-button" onClick={() => signOut()}>
              Sign Out
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
}

function AppShell() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  return (
    <div className="app-container">
      <header className="branding-header">
        <Link to="/" className="branding-link" tabIndex={-1} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 32 }}>
          <img src="/crossroads-logo.png" alt="Crossroads Co.Lab Logo" className="branding-logo" />
          <div className="branding-header-text">
            <span className="branding-title"> </span>
            <span className="branding-subtitle">Generative AI Tool</span>
          </div>
        </Link>
      </header>
      {!isLoginPage && <NavBar />}
      <main className={isLoginPage ? 'login-content' : 'main-content'}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><InferenceForm /></ProtectedRoute>} />
          <Route path="/logs" element={<ProtectedRoute><InferenceLogs /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppShell />
      </Router>
    </AuthProvider>
  );
}

export default App;
